import { render, staticRenderFns } from "./printOweFeeList.vue?vue&type=template&id=c23a72ea&scoped=true"
import script from "./printOweFeeList.vue?vue&type=script&lang=js"
export * from "./printOweFeeList.vue?vue&type=script&lang=js"
import style0 from "./printOweFeeList.vue?vue&type=style&index=0&id=c23a72ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23a72ea",
  null
  
)

export default component.exports